// extracted by mini-css-extract-plugin
module.exports = {"block":"_1Bu0k2","name":"_1qeRjR"};